import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import {Urls} from "../../constants/attachment/attachment.constants";
import { UpdateAttachmentsRequest } from "../../models/attachment/attachment.models";

@autoinject
export class RSAttachmentClientService {

    constructor(private requestClient: RequestClientService) {
    }

    public updateAttachments(request: UpdateAttachmentsRequest): Promise<void>
    {
        return this.requestClient.post(Urls.UpdateAttachments, {}, request);
    }
}
